const vehiclesInfos = [
  {
    "id": 0,
    "name": "Small",
  },
  {
    "id": 1,
    "name": "Medium",
  },
  {
    "id": 2,
    "name": "Large",
  },
  // {
  //   "id": 3,
  //   "name": "Tall",
  // },
  // {
  //   "id": 4,
  //   "name": "Very Tall",
  // },
]

export default vehiclesInfos
